const colors = {
  white: '#FFFFFF',
  neutral90: '#9C9BA3',
  neutral200: '#83828C',
  neutral700: '#474555',
  neutral900: '#302E40',
  neutral015: 'rgba(255, 255, 255, 0.15)',
  neutral06: 'rgba(255, 255, 255, 0.06)',
  neutral03: 'rgba(255, 255, 255, 0.03)',
  neutral300: '#767581',
  blue200: '#2B3A7E',
  blue75: '#969EBF',
  red300: '#F04923',
  red3004: '#F049230A',
  green3006: '#17A9750F',
  green300: '#17A975',
  green200: '#4CC3C1',
  red200: '#F36848',

  pageBg: '#060912',

  ellipseOrange: '#F04923',
  ellipseBlue: '#001264',

  error: '#D32F2F',

  modal: '#060912',
};

export { colors };
